import { itemColumnsAtom } from '@activities/items/ItemsActivity/atoms/itemFilterAtoms';
import useAppCustom from '@hooks/useAppCustom';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

function useItemColumn() {
    const setColumns = useSetAtom(itemColumnsAtom);
    const { gridColumns } = useAppCustom().items;
    useEffect(() => {
        if (gridColumns) {
            setColumns(gridColumns);
        }
    }, [gridColumns]);
}

export default useItemColumn;
